export const Panel = ({ title, right, children, className = "", testid }) => (
  <div
    data-testid={testid}
    className={`r2-panel flex flex-col overflow-hidden ${className}`}
  >
    <div className="flex items-center justify-between px-3 py-1.5 border-b border-[var(--r2-border)] shrink-0">
      <span className="text-[9.5px] font-mono font-semibold uppercase tracking-[0.2em] text-[var(--r2-text2)]">
        {title}
      </span>
      {right}
    </div>
    <div className="flex-1 min-h-0 flex flex-col">{children}</div>
  </div>
);
